import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Grid, Typography, Button } from '@mui/material';

const centerAlignStyle = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}

export const SurveyMain = ({ setStartSurvey }: any) => {
  return (
    <>
      <Grid item xs={12}>
        <Grid container>
          <Grid item xs={12}>
            <Typography color='primary' variant="h4" align="center">
              Thank you for your time!
            </Typography>
            <Typography color='primary' variant="h6" align="center">
              We would love to know your insights on the Metaverse experience...
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ ...centerAlignStyle, marginTop: '50px' }}>
            <Button onClick={() => setStartSurvey(false)} sx={{ borderRadius: '3rem', textTransform: 'capitalize', padding: '0.625rem 1.25rem' }} variant="contained" endIcon={<ArrowForwardIcon />} >Share your thoughts</Button>
          </Grid>
        </Grid>
      </Grid>
      <Grid container sx={{ position: 'absolute', bottom: '15px', right: '24px', justifyContent: 'flex-end' }}>
        <Typography color="primary" sx={{ m: "0 0 0.438rem 1.875rem" }}>
          If you wish to skip the survey, please close the browser window to exit the game.
        </Typography>
      </Grid>
    </>
  )
}